<template>
  <div>
    <div v-if="shouldShowEditor">
      <rich-text-editor v-model="newNoteBody" class="my-2"/>
      <div v-if="shouldShowAddButton" class="d-flex justify-end mt-2">
        <v-btn v-if="shouldShowAddButton" @click="addNote()" :loading="busy" color="primary">
          <v-icon>mdi-plus</v-icon>
          {{ $tc('note') }}
        </v-btn>
      </div>
    </div>
    <h6 class="mt-4" v-if="notes.length > 0">{{ $tc('previous_note', 2) }}:</h6>
    <v-card v-for="(note, index) in sortedNotes" :key="index" class="my-3 pt-1" color="blue-grey lighten-5">
      <v-subheader class="d-flex align-center">
        <span>{{ note.user_email }}</span>
        <v-chip class="ml-4" dark>
          <multi-time-display class="d-inline float-right" :time="note.created"/>
        </v-chip>
      </v-subheader>
      <v-divider/>
      <v-card-text v-html="note.note"/>
    </v-card>
  </div>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import RichTextEditor from '@/components/shared/RichTextEditor'
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay.vue'
import { indexOf, remove, cloneDeep } from 'lodash'

export default {
  name: 'ResourceNotes',
  mixins: [
    CurrentUserMixin
  ],
  data () {
    return {
      newNoteBody: '',
      busy: false
    }
  },
  props: {
    showEditor: {
      type: Boolean,
      default: undefined
    },
    showAddButton: {
      type: Boolean,
      default: undefined
    },
    notes: {
      type: Array,
      default: () => []
    },
    limitToContexts: {
      type: Array,
      default: () => []
    },
    iconMap: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {

    /**
     * Inspects the showEditor property and if unset by the parent inspects
     * the users permissions
     */
    shouldShowEditor: function () {
      if (this.showEditor !== undefined) {
        return this.showEditor
      }

      return this.user.can('create_note')
    },

    shouldShowAddButton: function () {
      if (!this.shouldShowEditor) {
        return false
      }

      if (this.showAddButton !== undefined) {
        return this.showAddButton
      }

      return this.user.can('create_note')
    },

    /**
     * Ensure the notes are sorted in descending order
     */
    sortedNotes () {
      const sortedNotes = cloneDeep(this.notes)
      if (this.limitToContexts.length > 0) {
        remove(sortedNotes, (note) => {
          return indexOf(this.limitToContexts, note.context) === -1
        })
      }
      sortedNotes.sort(function (a, b) {
        if (a.created === b.created) {
          return 0
        }
        return a.created > b.created ? -1 : 1
      })
      return sortedNotes
    }
  },
  methods: {
    addNote () {
      this.busy = true
      this.$emit('create-note', this.newNoteBody)
    },
    getNewNoteBody () {
      return this.newNoteBody
    },
    resetNoteBody () {
      this.newNoteBody = ''
    },
    newNoteSaveComplete () {
      this.busy = false
    },
    /**
     * Returns the icon associated to the note context (defined via the
     * contextMap when this component is created)
     *
     * @param {String} context
     * @return string|undefined
     */
    iconForContext (context) {
      return this.iconMap[context]
    }
  },
  components: {
    RichTextEditor,
    MultiTimeDisplay
  }
}
</script>
